import { useState, type ReactNode } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Flex, Typography, Upload, Button, UploadFile } from "antd";
import { Control } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { PdfIcon } from "@/shared/assets/svg/icons";
import { DocstoreUploadForm } from "../../model/types";
import "./modal-document-upload.scss";

interface IModalDocumentUpload {
  control: Control<DocstoreUploadForm>;
}

function DocumentUploadFileItem(
  _: ReactNode,
  file: UploadFile,
  __: UploadFile[],
  actions: { remove: () => void },
  onRemove: () => void,
) {
  return (
    <Flex
      gap="small"
      align="center"
      justify="space-between"
      className="file-name"
    >
      <Flex gap="small">
        <PdfIcon />
        <span>{file?.name}</span>
      </Flex>
      <DeleteOutlined
        style={{ cursor: "pointer" }}
        onClick={() => {
          actions.remove();
          onRemove();
        }}
      />
    </Flex>
  );
}

export function ModalDocumentUpload({ control }: IModalDocumentUpload) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  return (
    <Flex vertical gap="small" justify="center" className="document-upload">
      <FormItem<DocstoreUploadForm>
        name="document"
        control={control}
        style={{ marginBottom: 0 }}
      >
        <Upload
          accept=".pdf"
          fileList={fileList}
          showUploadList={{
            showPreviewIcon: false,
            showRemoveIcon: true,
            showDownloadIcon: false,
          }}
          itemRender={(originNode, file, fileListArg, actions) =>
            DocumentUploadFileItem(
              originNode,
              file,
              fileListArg,
              actions,
              () => setFileList([]),
            )
          }
          beforeUpload={(file) => {
            setFileList([file]);
            return false;
          }}
        >
          {fileList.length === 0 && (
            <Flex vertical gap="small">
              <Typography.Text>
                Загрузите требуемый документ с компьютера. <br /> PDF формат до
                10МБ
              </Typography.Text>
              <Button type="primary" className="document-upload-button">
                Загрузить документ
              </Button>
            </Flex>
          )}
        </Upload>
      </FormItem>
    </Flex>
  );
}
